import api from './index'
import { axios } from '@/utils/request'

export function getDonateList (parameter) {
  return axios({
    url: api.donate + '/list',
    method: 'get',
    params: parameter
  })
}
// 获取目录
export function directoryList(parameter) {
  return axios({
    url: '/act/directoryList',
    method: 'get',
    params:parameter
  })
}
//获取模板
export function getTemplateById(parameter) {
  return axios({
    url: '/act/getTemplateById',
    method: 'get',
    params:parameter
  })
}